// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search bar με στρογγυλές γωνίες, ίδιο στυλ με το υπόλοιπο UI */
.skill-selector-container input[type="text"],
input[type="text"].form-control {
    width: 100%;
    border-radius: 20px !important;
    padding: 10px 14px;
    font-size: 14px;
    border: 1px solid #ccc;
    outline: none;
    max-height: 30px !important;
    box-sizing: border-box;
}


/* Dropdown: να μην «πετάει» οριζόντιο scroll και να μην ξεχειλίζει */
.dropdown-suggestions {
    position: absolute;
    top: 50px;            /* κάτω από το search input (padding 10 + input 38 + ~2) */
    left: 10px;
    right: 10px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    z-index: 1000;        /* πάνω από badges/άλλα panels */
    min-width: 80px;
    max-height: 220px;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    padding: 2px;
}

.dropdown-item-skill {
    padding: 6px 10px;
    cursor: pointer;
    font-size: 13px;
    border-bottom: 1px solid #eee;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dropdown-item-skill:hover {
    background-color: #B7BABC;
}

.no-match {
    color: #888;
    font-style: italic;
    font-size: 12px;
    padding: 6px 10px;
}

/* Container για τα badges: κάθετο scroll όταν χρειαστεί, ποτέ οριζόντιο */
.selected-skills-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 0;
    /* ήταν 16px και δημιουργούσε «κενό» */
    max-width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}

.skill-badge {
    background-color: #F6F6F6 !important;
    padding: 4px 10px;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    color: black;
    font-weight: normal !important;
    height: 26px;
    max-width: 100%;
    box-sizing: border-box;
}

.badge-close {
    color: black;
    margin-left: 10px;
    font-size: 14px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
}

/* Μικρά breakpoints: λίγο πιο «άνετες» γραμματοσειρές/ύψη */
@media (max-width: 576px) {
    .dropdown-item-skill {
        font-size: 12px;
    }

    .skill-badge {
        font-size: 12px;
        height: 24px;
    }
}

/* --- Ellipsis για badges --- */
.skill-badge {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 8px;
    max-width: 100%;
    overflow: hidden;
    /* επιτρέπει στο κείμενο να κόβεται */
}

.skill-badge-text {
    flex: 1 1 auto;
    /* γεμίζει τον διαθέσιμο χώρο */
    min-width: 0;
    /* ΑΠΑΡΑΙΤΗΤΟ για ellipsis μέσα σε flex */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* να μη “μαζεύει” το X */
.badge-close {
    flex: 0 0 auto;
}

/* --- Ellipsis για dropdown items --- */
.dropdown-item-skill {
    display: flex;
    align-items: center;
    gap: 6px;
}

.dropdown-item-skill-text {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* === Base card for skill/step panels ===
   Η κλάση .boxStyle χρησιμοποιούνταν παντού αλλά ΔΕΝ οριζόταν πουθενά,
   με αποτέλεσμα τα κουτιά να εμφανίζονται χωρίς φόντο/περίγραμμα.
   Ίδιο look με τα υπόλοιπα γκρι cards (.q-steps-card). */
.boxStyle {
    background: #E5E7EB;
    border: 1px solid #bbb;
    border-radius: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, .15);
    box-sizing: border-box;
}

/* === 1) Το box των skills είναι flex column με scroll στη λίστα === */
.boxStyle.skills-box {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
    min-height: 0 !important;
    overflow: hidden;
}

.boxStyle.skills-box>input.form-control {
    flex: 0 0 40px !important;
    /* σταθερό ύψος για input */
    min-height: 40px !important;
    margin-bottom: 8px;
}

.boxStyle.skills-box>.skills-scroll {
    flex: 1 1 auto !important;
    /* παίρνει ΟΛΟ τον υπόλοιπο χώρο */
    min-height: 0 !important;
    overflow-y: auto !important;
    /* <-- ο ΜΟΝΟΣ scroller */
    overflow-x: hidden !important;
}

/* === 2) ΜΗ συρρίκνωση των badges ώστε να εμφανιστεί scroll === */
.skills-scroll {
    /* το container που έχει τα badges */
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.skills-scroll>* {
    /* ΚΑΘΕ badge/γραμμή μέσα στη λίστα */
    flex: 0 0 auto !important;
    /* ΔΕΝ συρρικνώνεται ποτέ */
}

/* Επιπλέον ασφάλεια για ύψος/ανάγνωση των badges */
.skill-badge {
    height: auto !important;
    min-height: 26px !important;
    line-height: 1.2 !important;
}

/* --- Safety ώστε να μη «κλέβονται» px από min-heights/margins --- */
.desc-col {
    min-height: 0;
}

.boxStyle.skills-box {
    min-height: 0;
    margin-bottom: 0 !important;
}

.skills-scroll {
    overflow-x: hidden;
}

/* --- Required skills (read-only list): long names wrap onto more lines
       instead of being cut off with "…" --- */
.skill-badge.skill-badge--wrap {
    white-space: normal !important;
    text-align: left;
    border-radius: 10px !important;
    padding: 6px 10px;
    line-height: 1.35 !important;
}

.skill-badge.skill-badge--wrap .skill-badge-text {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Description/SkillSelector.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;;IAEI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;AAC1B;;;AAGA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,SAAS,aAAa,0DAA0D;IAChF,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa,SAAS,gCAAgC;IACtD,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA,0EAA0E;AAC1E;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA,4DAA4D;AAC5D;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA,gCAAgC;AAChC;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,cAAc;AAClB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;yDAGyD;AACzD;IACI,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA,uEAAuE;AACvE;IACI,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,kEAAkE;AAClE;IACI,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,mDAAmD;AACnD;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,qEAAqE;AACrE;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;8CAC8C;AAC9C;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["/* Search bar με στρογγυλές γωνίες, ίδιο στυλ με το υπόλοιπο UI */\n.skill-selector-container input[type=\"text\"],\ninput[type=\"text\"].form-control {\n    width: 100%;\n    border-radius: 20px !important;\n    padding: 10px 14px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    outline: none;\n    max-height: 30px !important;\n    box-sizing: border-box;\n}\n\n\n/* Dropdown: να μην «πετάει» οριζόντιο scroll και να μην ξεχειλίζει */\n.dropdown-suggestions {\n    position: absolute;\n    top: 50px;            /* κάτω από το search input (padding 10 + input 38 + ~2) */\n    left: 10px;\n    right: 10px;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    z-index: 1000;        /* πάνω από badges/άλλα panels */\n    min-width: 80px;\n    max-height: 220px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n    padding: 2px;\n}\n\n.dropdown-item-skill {\n    padding: 6px 10px;\n    cursor: pointer;\n    font-size: 13px;\n    border-bottom: 1px solid #eee;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.dropdown-item-skill:hover {\n    background-color: #B7BABC;\n}\n\n.no-match {\n    color: #888;\n    font-style: italic;\n    font-size: 12px;\n    padding: 6px 10px;\n}\n\n/* Container για τα badges: κάθετο scroll όταν χρειαστεί, ποτέ οριζόντιο */\n.selected-skills-container {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 0;\n    /* ήταν 16px και δημιουργούσε «κενό» */\n    max-width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.skill-badge {\n    background-color: #F6F6F6 !important;\n    padding: 4px 10px;\n    font-size: 13px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 8px;\n    color: black;\n    font-weight: normal !important;\n    height: 26px;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.badge-close {\n    color: black;\n    margin-left: 10px;\n    font-size: 14px;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n/* Μικρά breakpoints: λίγο πιο «άνετες» γραμματοσειρές/ύψη */\n@media (max-width: 576px) {\n    .dropdown-item-skill {\n        font-size: 12px;\n    }\n\n    .skill-badge {\n        font-size: 12px;\n        height: 24px;\n    }\n}\n\n/* --- Ellipsis για badges --- */\n.skill-badge {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    gap: 8px;\n    max-width: 100%;\n    overflow: hidden;\n    /* επιτρέπει στο κείμενο να κόβεται */\n}\n\n.skill-badge-text {\n    flex: 1 1 auto;\n    /* γεμίζει τον διαθέσιμο χώρο */\n    min-width: 0;\n    /* ΑΠΑΡΑΙΤΗΤΟ για ellipsis μέσα σε flex */\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* να μη “μαζεύει” το X */\n.badge-close {\n    flex: 0 0 auto;\n}\n\n/* --- Ellipsis για dropdown items --- */\n.dropdown-item-skill {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.dropdown-item-skill-text {\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* === Base card for skill/step panels ===\n   Η κλάση .boxStyle χρησιμοποιούνταν παντού αλλά ΔΕΝ οριζόταν πουθενά,\n   με αποτέλεσμα τα κουτιά να εμφανίζονται χωρίς φόντο/περίγραμμα.\n   Ίδιο look με τα υπόλοιπα γκρι cards (.q-steps-card). */\n.boxStyle {\n    background: #E5E7EB;\n    border: 1px solid #bbb;\n    border-radius: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, .15);\n    box-sizing: border-box;\n}\n\n/* === 1) Το box των skills είναι flex column με scroll στη λίστα === */\n.boxStyle.skills-box {\n    display: flex !important;\n    flex-direction: column !important;\n    height: 100% !important;\n    min-height: 0 !important;\n    overflow: hidden;\n}\n\n.boxStyle.skills-box>input.form-control {\n    flex: 0 0 40px !important;\n    /* σταθερό ύψος για input */\n    min-height: 40px !important;\n    margin-bottom: 8px;\n}\n\n.boxStyle.skills-box>.skills-scroll {\n    flex: 1 1 auto !important;\n    /* παίρνει ΟΛΟ τον υπόλοιπο χώρο */\n    min-height: 0 !important;\n    overflow-y: auto !important;\n    /* <-- ο ΜΟΝΟΣ scroller */\n    overflow-x: hidden !important;\n}\n\n/* === 2) ΜΗ συρρίκνωση των badges ώστε να εμφανιστεί scroll === */\n.skills-scroll {\n    /* το container που έχει τα badges */\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.skills-scroll>* {\n    /* ΚΑΘΕ badge/γραμμή μέσα στη λίστα */\n    flex: 0 0 auto !important;\n    /* ΔΕΝ συρρικνώνεται ποτέ */\n}\n\n/* Επιπλέον ασφάλεια για ύψος/ανάγνωση των badges */\n.skill-badge {\n    height: auto !important;\n    min-height: 26px !important;\n    line-height: 1.2 !important;\n}\n\n/* --- Safety ώστε να μη «κλέβονται» px από min-heights/margins --- */\n.desc-col {\n    min-height: 0;\n}\n\n.boxStyle.skills-box {\n    min-height: 0;\n    margin-bottom: 0 !important;\n}\n\n.skills-scroll {\n    overflow-x: hidden;\n}\n\n/* --- Required skills (read-only list): long names wrap onto more lines\n       instead of being cut off with \"…\" --- */\n.skill-badge.skill-badge--wrap {\n    white-space: normal !important;\n    text-align: left;\n    border-radius: 10px !important;\n    padding: 6px 10px;\n    line-height: 1.35 !important;\n}\n\n.skill-badge.skill-badge--wrap .skill-badge-text {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
